import { render, staticRenderFns } from "./AdminDashboardFundingPotCompetition.vue?vue&type=template&id=7f12a8d7&"
import script from "./AdminDashboardFundingPotCompetition.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardFundingPotCompetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports